export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-950/40 via-background-50 to-background-50"></div>
        <div className="absolute top-0 right-0 w-2/3 h-full opacity-20">
          <div className="absolute top-1/4 right-10 w-96 h-96 rounded-full bg-primary-500/30 blur-3xl"></div>
          <div className="absolute bottom-1/4 right-1/3 w-64 h-64 rounded-full bg-accent-500/20 blur-3xl"></div>
        </div>
      </div>

      <div className="relative w-full px-4 md:px-6 pt-20 md:pt-24 pb-12 md:pb-16">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-5">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-xs font-medium text-primary-400">最新电影 · 经典重温 · 动作大片 · 喜剧精选</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-foreground-950 leading-tight">
              6080影院
              <span className="block text-primary-400 mt-1">
                电影大全免费在线高清点播平台
              </span>
            </h1>

            <p className="mt-2 text-sm md:text-base text-accent-400 font-medium font-heading tracking-wide">
              不缓冲 · 高清看 · 片库全 · 免费享
            </p>

            <div className="mt-5 md:mt-6 space-y-3">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
                6080影院打造真正的电影大全片库，覆盖最新电影、经典电影、动作电影、喜剧电影等全品类资源。
                每日持续更新片库，高清画质在线观看不缓冲播放，电脑手机随时随地免费看电影。
                当前暑期档片单已全面上线，海量佳片等你探索。
              </p>
            </div>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6">
              <div className="flex items-center gap-2">
                <i className="ri-movie-line text-accent-400 text-lg"></i>
                <span className="text-sm text-foreground-500">片库 <strong className="text-foreground-800 font-semibold">20,000+</strong> 部</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-timer-flash-line text-accent-400 text-lg"></i>
                <span className="text-sm text-foreground-500"><strong className="text-foreground-800 font-semibold">每日</strong> 更新上架</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-accent-400 text-lg"></i>
                <span className="text-sm text-foreground-500"><strong className="text-foreground-800 font-semibold">1080P</strong> 高清保障</span>
              </div>
            </div>

            <div className="mt-7 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => handleScroll(e, '#index')}
                className="w-full sm:w-auto px-8 py-3 text-sm font-semibold bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 rounded-md transition-all duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                <i className="ri-play-circle-line mr-2"></i>
                开始观影
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScroll(e, '#ranking')}
                className="w-full sm:w-auto px-8 py-3 text-sm font-medium text-foreground-700 hover:text-primary-400 border border-background-300 hover:border-primary-500/40 rounded-md transition-all duration-200 whitespace-nowrap text-center cursor-pointer bg-background-100/60"
              >
                <i className="ri-fire-line mr-2"></i>
                浏览热播排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/5] rounded-lg overflow-hidden border border-background-300/40">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20composition%20with%20deep%20red%20velvet%20curtains%20and%20golden%20stage%20lighting%2C%20classic%20movie%20theater%20atmosphere%2C%20dramatic%20spotlight%20on%20center%20stage%2C%20film%20noir%20aesthetic%20with%20rich%20shadows%2C%20premium%20cinema%20visual%20style%2C%20elegant%20dark%20background%20with%20warm%20accents%2C%208K%20cinematographic%20quality&width=600&height=750&seq=hero-cinema-main&orientation=portrait"
                alt="6080影院 - 电影大全免费在线高清点播平台主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-500/90 text-background-950 rounded-full">
                  每日更新 · 免费高清
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:block animate-bounce">
        <a
          href="#faq"
          onClick={(e) => handleScroll(e, '#faq')}
          className="text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-down-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}